import type { SymbolPackDTO } from '@nora-monorepo/nora-api-client';

import type { IdbStoreRecord } from '#ui-shared/idb-object-store/idb-object-store';
import { IdbObjectStore } from '#ui-shared/idb-object-store/idb-object-store';
import { symbolDatabase } from '#ui-shared/symbol-cache/symbol-database';

interface CachedSymbolPackRecord extends IdbStoreRecord {
  pack: SymbolPackDTO;
}

/**
 * IndexedDB-backed cache for symbol pack data. Symbol packs are stored in IndexedDB, allowing for efficient storage and retrieval of pack metadata. This cache is used to store metadata about symbol packs, while the actual symbol images are stored separately in the SymbolIdbCache.
 */
class SymbolPackIdbCache extends IdbObjectStore<CachedSymbolPackRecord> {
  constructor() {
    super({
      database: symbolDatabase,
      storeName: 'symbolPacks',
    });
  }

  async getPack(packId: string): Promise<SymbolPackDTO | undefined> {
    const record = await this.get(packId);

    return record?.pack;
  }

  async setPack(pack: SymbolPackDTO): Promise<void> {
    await this.put({ key: pack.id, pack });
  }

  deletePacksNotIn(validPackIds: Set<string>): Promise<string[]> {
    return this.deleteWhere(record => !validPackIds.has(record.pack.id));
  }
}

export const symbolPackIdbCache = new SymbolPackIdbCache();
